import EventCalendarAPI from '@/apis/business/teacher/event-calendar-api.js'
import { formatDate } from '@/utils/date'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,
  state: {
    calendarItem: null,
    calendarId: null,
    eventCalendars: [],
    calendarDate: new Date(),
    calendarSchedule: null,
    calendarExist: null,
    eventCalendarRecently: []
  },
  mutations: {
    /**
     * Set giá trị cho CalendarItem
     * @param {*} state
     * @param {*} data
     * VDDung1
     */
    setCalendarItem (state, data) {
      state.calendarItem = data
    },

    /**
     * Set Id cho Calendar
     * @param {*} state
     * @param {*} id
     * VDDung1
     */
    setCalendarId (state, id) {
      state.calendarId = id
    },

    /**
     * set list event calendar
     * @param {*} state
     * @param {*} data
     * VDDung1
     */
    setEventCalendars (state, data) {
      state.eventCalendars = data
    },

    /**
     * set giá trị thời gian cho calendar
     * @param {*} state
     * @param {*} date
     * VDDung1
     */
    setCalendarDate (state, date) {
      state.calendarDate = date
    },

    /**
     * set giá trị thông tin từ bảng schedule
     * @param {*} state
     * @param {*} title
     * VDDung1
     */
    setCalendarSchedule (state, data) {
      state.calendarSchedule = data
    },

    /**
     * set giá trị lịch học đã tồn tại
     * @param {*} state
     * @param {*} data
     * @author VDDung1
     */
    setCalendarExist (state, data) {
      state.calendarExist = data
    },

    /**
     * set giá trị lịch 7 ngày tới đây
     * @param {*} state
     * @param {*} data
     */
    setEventCalendarRecently (state, data) {
      state.eventCalendarRecently = data
    }
  },
  getters: {
    getEventCalendar (state) {
      state.calendarItem.StartTime = formatDate(
        state.calendarItem?.StartDate,
        'HH:mm'
      )
      state.calendarItem.FinishTime = formatDate(
        state.calendarItem?.EndDate,
        'HH:mm'
      )

      return state.calendarItem
    }
  },
  actions: {
    /**
     * Cất lịch học
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     * @update Sửa khi cất endDateRepeat -> lấy đến thời điểm cuối ngày được chọn
     * @author NTQuy
     */
    addEventCalendar (context, param) {
      return new Promise((resolve, reject) => {
        EventCalendarAPI.addEventCalendar(param)
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy ra lịch học theo id
     * @param {*} context
     * @param {*} id
     * @returns
     * @author VDDung1
     */
    getEventCalendar (context, id) {
      return new Promise((resolve, reject) => {
        EventCalendarAPI.getEventCalendar(id)
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setCalendarItem', res?.Data)
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách lịch học theo tuần
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    getListEventCalendar (context, param) {
      return new Promise((resolve, reject) => {
        EventCalendarAPI.getAsync('list', { params: param })
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setEventCalendars', res?.Data)
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách lịch 7 ngày tới đây
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    getEventCalendarRecently (context, param) {
      return new Promise((resolve, reject) => {
        EventCalendarAPI.getAsync('list', { params: param })
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setEventCalendarRecently', res?.Data)
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Kiểm tra sự tồn tại của lịch học hay chưa
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    checkExistEventCalendar (context, param) {
      return new Promise((resolve, reject) => {
        EventCalendarAPI.postAsync('calendar-schedule', param)
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              resolve(true)
              context.commit('setCalendarExist', res?.Data)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cập nhật lịch học
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    updateEventCalendar (context, param) {
      return new Promise((resolve, reject) => {
        EventCalendarAPI.postAsync('calendar-item', param)
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Xóa lịch học
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    deleteEventCalendar (context, param) {
      return new Promise((resolve, reject) => {
        EventCalendarAPI.deleteAsync('calendar-item', { params: param })
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
